import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { ResponseModel } from '../models/core/ResponseModel.model';
import { API_CONFIG } from '../../environments/environment';

@Injectable()
export class CoreService {
  constructor(private http: HttpClient) {

  }
  public baseUrl = API_CONFIG.CORE_API;
  public storeUrl = API_CONFIG.STORE_API;
  public manageURL = API_CONFIG.ACCOUNTMANAGEMENT_API2;
  public identityUrl = API_CONFIG.IDENTITY_API;

  private createAuthorizationHeader(tenantId?: string) {
    const headers = {};
    if(tenantId) {
      headers['instanceID'] = tenantId;
    }

    return headers;
  }

  private formatErrors(error: any) {
    console.log(error.error);
    return throwError(error);
  }

  public get(url: string, tenantId?: string): Observable<ResponseModel<any>> {
    const headers = this.createAuthorizationHeader(tenantId);
    return this.http.get<ResponseModel<any>>(url, { headers: headers })
      .pipe(catchError(this.formatErrors));
  }

  public post(url: string, obj: any, tenantId?: string): Observable<ResponseModel<any>> {
    const headers = this.createAuthorizationHeader(tenantId);
    return this.http.post<ResponseModel<any>>(url, obj, { headers: headers })
      .pipe(catchError(this.formatErrors));
  }
  public postProgress(url: string, obj: any, tenantId?: string): Observable<any> {
    const headers = this.createAuthorizationHeader(tenantId);
    return this.http.post(url, obj, { headers: headers, reportProgress: true })
      .pipe(catchError(this.formatErrors));
  }
  public put(url: string, obj: any, tenantId?: string): Observable<ResponseModel<any>> {
    const headers = this.createAuthorizationHeader(tenantId);
    return this.http.put<ResponseModel<any>>(url, obj, { headers: headers })
      .pipe(catchError(this.formatErrors));
  }
  public delete(url: string, tenantId?: string): Observable<ResponseModel<any>> {
    const headers = this.createAuthorizationHeader(tenantId);
    return this.http.delete<ResponseModel<any>>(url, { headers: headers })
      .pipe(catchError(this.formatErrors));
  }
}
